import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetBookingsTutor = ({ status }: { status: string }) => {
  const token = localStorage.getItem("W2ST_TUTOR_TOKEN");

  return useQuery({
    queryKey: ["getBookingsTutor", status],
    queryFn: async () => {
      if (!token) {
        throw new Error("Token not found");
      }

      const config: any = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (status !== "") {
        config.params = { status };
      }

      const response = await axiosInstance.get("/tutors/bookings", config);
      return response.data;
    },
    onSuccess: (data) => {},
    onError: (error) => {
      console.error("Error fetching user data:", error);
    },
  });
};
